import { lazy } from 'react'

const KidsList = lazy(() => import('../../views/customers/childManager'))

const Record = lazy(() =>
  import('../../views/customers/bacamiga-wallet/record')
)
const Wallet = lazy(() =>
  import('../../views/customers/bacamiga-wallet/wallet')
)
const WithdrawRoutes = [
  {
    path: '/customer/dashboard',
    element: <KidsList />
  },
  {
    path: '/customer/record',
    element: <Record />
  },
  {
    path: '/customer/wallet',
    element: <Wallet />
  }
]

export default WithdrawRoutes
